import { Box, Button, HStack, IconButton, Text,Flex } from "@chakra-ui/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { useState } from "react";

const Pagination = ({ totalPages = 10 }) => {
  const [currentPage, setCurrentPage] = useState(3);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPaginationRange = () => {
    const siblings = 1;
    const totalNumbers = siblings + 5;
    const range = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - siblings && i <= currentPage + siblings)) {
        range.push(i);
      }
    }

    if (range[1] !== 2) range.splice(1, 0, "...");
    if (range[range.length - 2] !== totalPages - 1) range.splice(range.length - 1, 0, "...");

    return range;
  };

  return (
    <Flex justifyContent="center" alignItems="center" height="100vh">

    <HStack spacing={2}>
      <IconButton
        icon={<ArrowLeftIcon />}
        isDisabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
        aria-label="Previous"
        color="black"
        mx={2} // Increase space between numbers
        _hover={{
          bg: "gray.300",
          padding: "6px",
          borderRadius: "6px", // Make square on hover
        }}
        transition="transform 0.2s" // Smooth transition for scaling
        borderRadius="lg"
        size="sm" // Match size with number buttons
      />

      {getPaginationRange().map((page, index) => (
        <Button
          key={index}
          onClick={() => typeof page === 'number' && handlePageChange(page)}
          isDisabled={typeof page !== 'number'}
          variant={page === currentPage ? "solid" : "outline"}
          color="black"
          mx={2} // Increase space between numbers
          _hover={{
            bg: "gray.300",
            paddingLeft: "5px",
            paddingRight: "5px",
            paddingTop: "4px",
            paddingBottom: "4px",
            borderRadius: "6px", // Make square on hover
          }}
          transition="transform 0.2s" // Smooth transition for scaling
          borderRadius="lg"
        >
          {page}
        </Button>
      ))}

      <IconButton
        icon={<ArrowRightIcon />}
        isDisabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
        aria-label="Next"
        color="black"
        mx={2} // Increase space between numbers
        _hover={{
          bg: "gray.300",
          padding: "6px",
           // Increase size of the button on hover
          borderRadius: "6px", // Make square on hover
        }}
        transition="transform 0.2s" // Smooth transition for scaling
        borderRadius="lg"
        size="sm" // Match size with number buttons
      />
    </HStack>
    </Flex>
  );
};

export default Pagination;